module.exports = __webpack_public_path__ + "static/media/royal-flora-logo2x.6ef0c95e.png";